/**
 *   Name: ModalBox.js
 * Author: Francisco J. O'Meany
 * Description: Modal class component for all applications developed by Netequal Technology Solutions & Vysel
 *
 * Copyright (c) 2024 - Netequal Technology Solutions
 *
 */
import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import AccounTabs from '../Accounts/AccounTabs';
import jQuery from 'jquery';
import 'jquery-ui/ui/widgets/draggable';
import './ModalBox.css';

class ModalBox extends React.Component {
    constructor(props) {
        super(props);                                                                                           //- In React version 18+, a change was made to strict mode so 
        this.mounted	    = false;																					                                    //- that components will mount, then unmount, then mount again. 
        this.state        = { show: props.show };                                                               //- Set show state for this modal box
        this.submitBtnId  = ( props.submitBtnId  ? props.submitBtnId  : "appSubmitBtn" );                       //- Submit button id
        this.closeBtnId   = ( props.appCloseBtn  ? props.appCloseBtn  : "appCloseBtn" );                        //- Close button id
        this.modalMsgsId  = ( props.modalMsgsId  ? props.modalMsgsId  : "appModalMsgs" );                       //- Modal messages id
        this.modalBodyId  = ( props.modalBodyId  ? props.modalBodyId  : "appModalBody" );                       //- Modal body div id
        this.modalTitleId = ( props.modalTitleId ? props.modalTitleId : "appModalTitle" );                      //- Modal title id
        this.modalBoxId   = ( props.modalBoxId   ? props.modalBoxId   : "appDialogBox" );                       //- Modal dialgo box id
    }

    componentDidMount() {
      const self		= this;
          if( !self.mounted ) {                                                                                 //- the component has not been mounted (is mounted twice by React)
            if( self.props.title !== undefined && self.props.title !== "" ) {
              document.getElementById( this.modalTitleId ).innerHTML = self.props.title;                        //- Set modal box title
            }
            if( document.getElementById( this.modalTitleId ) ) {
              jQuery( "#" + this.modalBoxId ).draggable({												                                //- Make dialog draggable
                handle: ".modal-header"
              });
            }
            self.mounted = true;                                                                                //- Mark component as mounted
          }
    }

    setModalClosed = () => {
      this.setState({ show: false });
    }

    render() {
        return(
            <Modal show={this.state.show}
                    onHide={() => this.setModalClosed(false)}
                    onExited={() => this.props.onExit()}
                    keyboard={false}
                    backdrop={true}
                    size={ this.props.size }
                    aria-labelledby={this.modalTitleId}
                    id={this.modalBoxId}
                    centered>
            
              <Modal.Header closeButton>
                <Modal.Title id={this.modalTitleId}></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div id={this.modalBodyId}></div>
                { this.props.showTabs && <AccounTabs onTabSelect={this.props.onTabSelect} tabKey={this.props.tabKey} />}
              </Modal.Body>
              <Modal.Footer>
                <div className="row w-75 position-absolute app-modal-msgs">
                  <div id={this.modalMsgsId} className='col-lg-12'></div>
                </div>
                { this.props.submit && 
                <Button id={this.submitBtnId} className={"app-submit-btn"}>{this.props.submitBtn}</Button> }
                <Button id={this.closeBtnId} onClick={this.setModalClosed}>{this.props.closeBtn}</Button>
              </Modal.Footer>
            </Modal>
        );
    }
}

export default ModalBox;